import { useBreakpoint, DEFAULT_BREAKPOINT } from '@hub/design-system-base'
import React from 'react'
import { AccountPaneLarge } from './large'
import { AccountPaneSmall } from './small'
import { AccountPaneProps } from './types'

export const AccountPane: React.FC<AccountPaneProps> = props => {
  const breakpoint = useBreakpoint(DEFAULT_BREAKPOINT)

  const isSmallLayout = ['base', 'sm'].includes(breakpoint || 'base')

  return isSmallLayout ? (
    <AccountPaneSmall {...props} />
  ) : (
    <AccountPaneLarge {...props} />
  )
}
